function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "481D1602-8BBB-419F-B87B-78F456CBD656");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M12.4705,7 C12.1807,6.1873 11.4107,5.6 10.5,5.6 L4.2,5.6 L4.2,4.2 L12.6,4.2 L12.6,7 L12.4705,7 Z M10.5,8.4 L7.7,8.4 C7.3983,8.4 7.1309,8.5925 7.0357,8.8788 L5.817,12.5342 L1.4,11.9819 L1.4,4.6326 L2.8,3.9326 L2.8,6.3 C2.8,6.6871 3.1129,7 3.5,7 L10.5,7 C10.8857,7 11.2,7.3136 11.2,7.7 C11.2,8.0864 10.8857,8.4 10.5,8.4 L10.5,8.4 Z M4.2,2.8 L12.6,2.8 L12.6,1.4 L4.2,1.4 L4.2,2.8 Z M13.3,0 L3.5,0 C3.1129,0 2.8,0.3129 2.8,0.7 L2.8,2.3674 L0.3864,3.5735 C0.1491,3.6925 0,3.9347 0,4.2 L0,12.6 C0,12.9528 0.2632,13.251 0.6132,13.2944 L6.2132,13.9944 C6.2426,13.9979 6.2713,14 6.3007,14 C6.5975,14 6.8677,13.8103 6.9636,13.5212 L8.204,9.8 L10.5,9.8 C11.4107,9.8 12.1807,9.2127 12.4705,8.4 L13.3,8.4 C13.6864,8.4 14,8.0871 14,7.7 L14,0.7 C14,0.3129 13.6864,0 13.3,0 L13.3,0 Z",
  id: "path-3"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design-systems",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Form-elements",
  transform: "translate(-748.000000, -785.000000)"
}, React.createElement("g", {
  id: "icon/payment",
  transform: "translate(748.000000, 785.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-3"
})), React.createElement("use", {
  id: "Icon",
  fill: "#42526E",
  fillRule: "evenodd",
  xlinkHref: "#path-3"
}))));

var SvgPaymentIcon = function SvgPaymentIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPaymentIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment-icon.e0eabc34.svg";
export { ForwardRef as ReactComponent };